/**
 * Products Services Module
 * Exports all product management services and factory functions
 */
// Service exports (one per controller)
export * from './ProductService';
export * from './ProductTypeService';
export * from './ProductColorService';
export * from './ProductSizeService';
export * from './ProductImageService';
export * from './ProductStockService';
export * from './ProductTransactionService';
export * from './TransactionTypeService';
// Service imports for factory
import { ProductService } from './ProductService';
import { ProductTypeService } from './ProductTypeService';
import { ProductColorService } from './ProductColorService';
import { ProductSizeService } from './ProductSizeService';
import { ProductImageService } from './ProductImageService';
import { ProductStockService } from './ProductStockService';
import { ProductTransactionService } from './ProductTransactionService';
import { TransactionTypeService } from './TransactionTypeService';
/**
 * Create all products services with shared configuration
 * @param http - HTTP client instance
 * @param config - Service configuration (servicePath, endpoints)
 * @returns Object containing all products service instances
 */
export function createProductsServices(http, config) {
    return {
        product: new ProductService(http, config),
        productType: new ProductTypeService(http, config),
        productColor: new ProductColorService(http, config),
        productSize: new ProductSizeService(http, config),
        productImage: new ProductImageService(http, config),
        productStock: new ProductStockService(http, config),
        productTransaction: new ProductTransactionService(http, config),
        transactionType: new TransactionTypeService(http, config),
    };
}
//# sourceMappingURL=index.js.map